'use client';

import { useEffect, useRef, useState } from 'react';
import { ImageGrid } from './office/ImageGrid';
import { ContentOverlay } from './office/ContentOverlay';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function OfficeSection({ dictionary }: { dictionary: any }) {
  const [scrollY, setScrollY] = useState(0);
  const [windowWidth, setWindowWidth] = useState(1024);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (sectionRef.current) {
        const rect = sectionRef.current.getBoundingClientRect();
        // Bereken de scroll-offset t.o.v. het begin van de sectie
        const offset = -rect.top;
        setScrollY(offset);
      }
    };

    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);
    // Stel de huidige breedte meteen in
    handleResize();

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Parallax actief als windowWidth ≥ 1024px
  const disableParallax = windowWidth < 1024;

  if (disableParallax) {
    // Mobiele / grid layout: ContentOverlay bovenaan en daarna de grid
    return (
      <div className='w-full bg-white'>
        <section className='relative bg-white mx-auto max-w-screen-xl px-4 py-8'>
          {/* ContentOverlay bovenaan (normale flow) */}
          <ContentOverlay disableParallax={disableParallax} dictionary={dictionary} />
          {/* De afbeeldingen komen in een grid */}
          <div className='mt-8'>
            <ImageGrid scrollY={scrollY} disableParallax={disableParallax} />
          </div>
        </section>
      </div>
    );
  }

  // Desktop / parallax layout: sticky container met parallax‑effect
  return (
    <div className='w-full bg-white'>
      {/* Voldoende scrollruimte (200vh) zodat het effect in deze sectie plaatsvindt */}
      <section ref={sectionRef} className='relative h-[200vh] bg-white mx-auto max-w-screen-xl px-4 py-8'>
        {/* Sticky container zodat de parallax-laag binnen deze sectie blijft */}
        <div className='sticky top-0 w-full h-screen'>
          <ImageGrid scrollY={scrollY} disableParallax={disableParallax} />
          <ContentOverlay disableParallax={disableParallax} dictionary={dictionary} />
        </div>
      </section>
    </div>
  );
}
